/* tslint:disable */
import {
  Product,
  ProductUom
} from '../index';

declare var Object: any;
export interface PurchaseOrderLineInterface {
  "id"?: number;
  "name": string;
  "active"?: boolean;
  "product_id"?: number;
  "product_uom"?: number;
  product?: Product;
  uom?: ProductUom;
}

export class PurchaseOrderLine implements PurchaseOrderLineInterface {
  "id": number;
  "name": string;
  "active": boolean;
  "product_id": number;
  "product_uom": number;
  product: Product;
  uom: ProductUom;
  constructor(data?: PurchaseOrderLineInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `PurchaseOrderLine`.
   */
  public static getModelName() {
    return "PurchaseOrderLine";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of PurchaseOrderLine for dynamic purposes.
  **/
  public static factory(data: PurchaseOrderLineInterface): PurchaseOrderLine{
    return new PurchaseOrderLine(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'PurchaseOrderLine',
      plural: 'PurchaseOrderLines',
      path: 'PurchaseOrderLines',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
        "name": {
          name: 'name',
          type: 'string'
        },
        "active": {
          name: 'active',
          type: 'boolean'
        },
        "product_id": {
          name: 'product_id',
          type: 'number'
        },
        "product_uom": {
          name: 'product_uom',
          type: 'number'
        },
      },
      relations: {
        product: {
          name: 'product',
          type: 'Product',
          model: 'Product',
          relationType: 'belongsTo',
                  keyFrom: 'product_id',
          keyTo: 'id'
        },
        uom: {
          name: 'uom',
          type: 'ProductUom',
          model: 'ProductUom',
          relationType: 'belongsTo',
                  keyFrom: 'product_uom',
          keyTo: 'id'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/PurchaseOrderLine.ts